import styled from 'styled-components';

const DetailsInner = styled.div`
  margin: 30px 0px;
`;

DetailsInner.displayName = 'DetailsInner';

export default DetailsInner;
